import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="font-heading text-xl md:text-2xl font-bold tracking-tight text-foreground-50 transition-colors"
              style={isScrolled ? { color: 'oklch(var(--primary-500))' } : {}}
            >
              韩漫网站
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.href
                    ? isScrolled
                      ? 'text-primary-500 bg-primary-100/70'
                      : 'text-white bg-white/20'
                    : isScrolled
                      ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/all"
              className={`px-5 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
              aria-label="开始阅读"
            >
              开始阅读
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl transition-colors ${
                isScrolled ? 'text-foreground-800' : 'text-white'
              } ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                  location.pathname === link.href
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-3">
              <Link to="/category/all" className="w-full px-5 py-3 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-center block">
                开始阅读
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}